import React from 'react';
import { Crown } from 'lucide-react';

/**
 * Special gold badge shown ONLY on Christ Kingdom Apparel (house-brand / POD)
 * products. Visually distinct from the generic Trusted Seller badge so buyers
 * recognize official platform merchandise instantly.
 */
export const OfficialMerchBadge = ({ size = 'md', className = '' }) => {
  const sizeClasses = size === 'lg' ? 'h-5 w-5' : 'h-4 w-4';
  const textClasses = size === 'lg' ? 'text-sm' : 'text-xs';
  return (
    <div
      className={`inline-flex items-center gap-1.5 ${textClasses} bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400 text-amber-900 px-2.5 py-1 rounded-full shadow-sm font-semibold border border-amber-500/40 ${className}`}
      title="Official Christ Kingdom merchandise — designed, branded, and fulfilled by the platform"
      data-testid="official-merch-badge"
    >
      <Crown className={`${sizeClasses} fill-amber-700/20`} />
      <span>Official Merch</span>
    </div>
  );
};

export default OfficialMerchBadge;
